var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view engagement-management"},[_vm._m(0),_c('div',{staticClass:"content"},[_c('file-search',{attrs:{"engagementsService":_vm.engagementsService,"s3Service":_vm.s3Service}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("File search")])])
}]

export { render, staticRenderFns }